<template>
  <div>
    <font-awesome-icon
      v-b-modal.list-reminders
      :class="reminders && reminders.length > 0 ? 'reminder' : 'muted reminder'"
      :icon="['fal', 'alarm-exclamation']"
    />
    <span v-if="unresolvedCount" class="badge badge-warning badge-pill count">
      {{ unresolvedCount }}
    </span>

    <b-modal id="list-reminders" ref="listRemindersModalRef" size="lg" title="Reminders">
      <ul class="list-group reminder-list overflow-y-auto" style="max-height: 353px">
        <li
          v-for="reminder in reminders"
          :key="reminder.id"
          :class="reminder.resolved ? 'past' : ''"
          class="list-group-item position-relative"
        >
          <font-awesome-icon
            v-if="reminder.important"
            :icon="['fal', 'exclamation-triangle']"
            class="text-danger"
          />

          <b :class="reminder.resolved ? 'resolved-color' : 'pending-color'">
            {{ reminder.action }}
          </b>

          <a :href="`/reminders/${reminder.id}/edit`" target="_blank">
            <font-awesome-icon :icon="['fal', 'external-link']" />
          </a>

          <div>
            {{ reminder.notes }}
          </div>

          <div>
            <div class="text-muted d-inline-block">
              <small>
                Due: {{ formatDate(reminder.due_date, "ddd DD MMM YYYY") }}@{{ reminder.user.name }}
              </small>
            </div>
          </div>
          <div v-if="!reminder.resolved" class="resolve position-absolute cursor">
            <font-awesome-icon :icon="['fal', 'thumbs-up']" @click="resolve(reminder.id)" />
          </div>
        </li>
      </ul>

      <div v-if="reminders && reminders.length === 0" class="text-center lead py-3">
        There are currently no reminders for this job
      </div>

      <template #modal-footer>
        <div class="w-100">
          <b-btn v-b-modal.new-reminder class="float-right" size="sm" variant="primary">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Add Reminder
          </b-btn>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script type="text/babel">
import format from "../../../mixins/format";
import EventBus from "../../../imports/event-bus";

export default {
  mixins: [format],

  props: ["job"],

  data() {
    return {
      reminders: null,
    };
  },

  computed: {
    unresolvedCount() {
      if (this.reminders && this.reminders.length > 0) {
        return this.reminders.filter((reminder) => !reminder.resolved).length;
      }
      return 0;
    },
  },

  watch: {
    job() {
      this.init();
    },
  },

  mounted() {
    this.init();

    EventBus.$on("reminder-updated", () => {
      this.init();
    });
  },

  methods: {
    init() {
      this.reminders = null;

      if (this.$lodash.has(this.job, "id")) {
        this.$http.get(`/jobs/${this.job.id}/reminders?limit=999`).then((response) => {
          if (response.status === 200) {
            this.reminders = response.body.data;
          }
        });
      }
    },

    resolve(id) {
      window
        .sweetAlert({
          title: "Confirm to resolve this reminder",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes!",
          },
        })
        .then((confirmed) => {
          if (confirmed) {
            this.$http.put(`/reminders/${id}/resolve`).then((response) => {
              if (response.status === 200) {
                window.toastr.success("Reminder resolved!", "Success");
                EventBus.$emit("reminder-updated");
              } else {
                window.toastr.warning(
                  "Something went wrong when trying to resolve this reminder!",
                  "Warning"
                );
              }
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.reminder {
  position: relative;
  color: #40aade;
  font-size: 26px;
  margin-left: 8px;
  cursor: pointer;
}

.reminder.muted {
  color: #c7cbd4;
}

.header-icons .count.badge {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: 6px;
}

.resolved-color {
  color: #4db685;
}

.pending-color {
  color: #fa5758;
}

.reminder-list {
  .resolve {
    width: 60px;
    height: 89px;
    line-height: 89px;
    text-align: center;
    right: 0;
    top: 0;
    font-size: 18px;
    color: #a0c4de;
  }

  .resolve:hover {
    color: #00b607;
  }
}
</style>
